export const ACTIONS_ELECTION_OBSERVERS = {
	ELECTION_OBSERVERS_MANAGE: 'election_observers_manage',
} as const;
